import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import { zeroFill } from '../../../../Utils/actions'
import moment from 'moment'

import calidad from '../../../../../logo/calidad.png'
import plantilla from '../../../../../logo/plantilla_encabezado_reportes_laridae.png'
import { estilos } from './styles'

const styles = StyleSheet.create(estilos)

const leyendaTrigo = 'En atención al rechazo de clientes del exterior a la recepción de trigo genéticamente modificado -HB4- y al sistema de pérdida de identidad de esta Terminal, por requerimiento de los exportadores y hasta nuevo aviso la Terminal no recibirá trigo de esa condición, por lo que se requiere de los vendedores el debido control previo de la mercadería que enviarán a la Terminal.' +
'Sin perjuicio del control de los vendedores, la Terminal procederá al método de escaneo para control en cada camión y en caso de resultado positivo no se descargará el mismo hasta obtener el resultado en análisis de PCR, sin responsabilidad alguna de esta Terminal por las demoras al vehículo y la descarga, o por el definitivo rechazo de la mercadería. Retendrá asimismo muestras lacradas por camión,' +
' las que quedarán en depósito de nuestra empresa/Cámara Arbitral para otros análisis que se requieran.' +
'Los análisis que esta Terminal realice sobre la mercadería no implicará seguridad respecto del resultado obtenido ni asunción por la Terminal de responsabilidad alguna.' +
'Si pese a lo expuesto se diera una contaminación o se diera algún rechazo o perjuicio a cualquiera de las partes en la exportación, todos los daños y perjuicios, sin limitación alguna, frente a exportadores o compradores o destinatarios del exterior y frente a esta Terminal serán a cargo del vendedor.'

/* Funcion para Generar reportes en PDF

Props:
info, objeto que contiene
}
  titulo: 'Detalle Descargada',
  subtitulo: 'Entre fechas'
  version: 'Version de Laridae'
}
fields, arreglo de objetos
    {
      name: 'cartaDePorte',
      label: 'Carta de Porte',
      width: '70'
    }
data, arreglo de objetos
TODO: Ancho de columnas automatico
*/

const GenerarDescargaPdf = (props) => {
  const info = props.info || {}
  const data = props.data

  return (
    <Document
      author='Terminal Quequén S.A.'
      subject='Certificado de Descarga'
      title={info.titulo || `Certificado de Descarga CTG ${data.cartaDePorteAutomotor}`}
    >
      <Page size='A4' orientation={props.orientation} style={styles.page} wrap>
        <Image src={plantilla} style={styles.logo} fixed />
        <Text style={styles.titlePrincipal}>{(info.acta !== 'null') ? `(*) C.P.E.: ` : `C.P.E.: `}{zeroFill(data.cpeSucursal, 5)}-{zeroFill(data.cpeSecuencia, 8)}</Text>
        <Text style={[styles.titlePrincipal, { paddingBottom: 20 }]}>C.T.G.:
          <Text style={{ fontFamily: 'Helvetica-Bold' }}> {data.cartaDePorteAutomotor}</Text>
        </Text>
        <View>
          {data &&
            <View >
              <View style={{ display: 'flex', flexDirection: 'row' }}>
                <Text style={styles.subtitleIzq}>
                  <Text style={{ fontFamily: 'Helvetica-Bold' }}>Exportador: </Text>
                  {data.exportador}
                </Text>
                <Text style={styles.subtitleDer}>{data.cuitExportador}</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row' }}>
                <Text style={styles.subtitleIzq}>
                  <Text style={{ fontFamily: 'Helvetica-Bold' }}>Representante: </Text>
                  {data.representante}
                </Text>
                <Text style={styles.subtitleDer}>{data.cuitRepresentante}</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row' }}>
                <Text style={styles.subtitleIzq}>
                  <Text style={{ fontFamily: 'Helvetica-Bold' }}>Corredor Vta. Pri.: </Text>
                  {data.corredorComprador}
                </Text>
                <Text style={styles.subtitleDer}>{data.cuitCorredorComprador}</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row' }}>
                <Text style={styles.subtitleIzq}>
                  <Text style={{ fontFamily: 'Helvetica-Bold' }}>Corredor Vta. Sec.: </Text>
                  {data.corredorVendedor}
                </Text>
                <Text style={styles.subtitleDer}>{data.cuitCorredorVendedor}</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row' }}>
                <Text style={styles.subtitleIzq}>
                  <Text style={{ fontFamily: 'Helvetica-Bold' }}>Rtte. Comercial: </Text>
                  {data.remitenteComercial}
                </Text>
                <Text style={styles.subtitleDer}>{data.cuitRemitenteComercial}</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row' }}>
                <Text style={styles.subtitleIzq}>
                  <Text style={{ fontFamily: 'Helvetica-Bold' }}>Titular: </Text>
                  {data.titular}
                </Text>
                <Text style={styles.subtitleDer}>{data.cuitTitular}</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row' }}>
                <Text style={styles.subtitleIzq}>
                  <Text style={{ fontFamily: 'Helvetica-Bold' }}>Transportista: </Text>
                  {data.transportista}
                </Text>
                <Text style={styles.subtitleDer}>{data.cuitTransportista}</Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row' }}>
                <Text style={[styles.subtitleIzq, { borderBottom: 1, paddingBottom: 15 }]}>
                  <Text style={{ fontFamily: 'Helvetica-Bold' }}>Camión: </Text>
                  {data.camion}
                </Text>
              </View>
              <View style={{ display: 'flex', flexDirection: 'row' }}>
                <Text style={[styles.title, { fontSize: 18, textAlign: 'left' }]}>{data.cereal}</Text>
                {data.calificacionCereal &&
                  <Text style={[styles.subtitleDer, { fontSize: 18 }]}>{data.calificacionCereal}</Text>}
              </View>
              <Text style={[styles.title, { fontSize: 18, textAlign: 'left' }]}>Humedad: {data.humedad}</Text>

              <Text style={styles.subtitleIzq}>Neto de origen: {data.pesoNetoOrigen}</Text>
              <Text style={styles.subtitleIzq}>Destare: {moment(data.fechaDeDestare, 'YYYY-MM-DD H:mm:ss').format('DD/MM/YYYY H:mm:ss')}</Text>
              <Text style={styles.subtitleIzq}>Fecha de Descarga:
                <Text style={{ fontFamily: 'Helvetica-Bold' }}> {moment(data.fechaDeDescarga, 'YYYY-MM-DD').format('DD/MM/YYYY')}</Text>
              </Text>
              <Text style={[styles.title, { fontSize: 18, textAlign: 'left', backgroundColor: 'black', color: 'white' }]}>Neto CTG: {data.pesoNetoCtg}</Text>
              <View style={styles.table}>
                <View style={styles.tableRow} wrap={false}>
                  <View style={[styles.tableCol, { width: '20%' }]}>
                    <Text style={styles.tableCell}>Bruto: {data.pesoBruto}</Text>
                  </View>
                  <View style={[styles.tableCol, { width: '20%' }]}>
                    <Text style={styles.tableCell}>Tara: {data.pesoTara}</Text>
                  </View>
                  <View style={[styles.tableCol, { width: '20%' }]}>
                    <Text style={styles.tableCell}>Neto: {data.pesoNeto}</Text>
                  </View>
                  <View style={[styles.tableCol, { width: '20%' }]}>
                    <Text style={styles.tableCell}>Merma: {data.merma}</Text>
                  </View>
                  <View style={[styles.tableCol, { width: '20%' }]}>
                    <Text style={styles.tableCell}>Neto CTG: {data.pesoNetoCtg}</Text>
                  </View>
                </View>
              </View>
              <Text style={[styles.title, { fontSize: 18, paddingTop: 20 }]}>Certificado de Descarga:
                <Text style={{ fontFamily: 'Helvetica-Bold' }}> {data.numeroDeMuestra}</Text>
              </Text>
              {data.fumigado &&
                <Text style={[styles.subtitleIzq, { textAlign: 'center' }]}>*** CEREAL FUMIGADO - TQ S.A. ***</Text>}
              {data.cerealAdherido &&
                <Text style={[styles.subtitleIzq, { textAlign: 'center' }]}>Destara camión con mercadería adherida al piso - TQ S.A.</Text>}
              {(info.acta !== 'null') &&
                <Text style={[styles.subtitleIzq, { textAlign: 'center' }]}>* CPE interdicta. Acta: {info.acta}</Text>}
              {(data.cereal === 'Trigo Pan') &&
                <Text style={[styles.leyenda]}>{leyendaTrigo}</Text>}
            </View>
          }
        </View>
        {info.total && <Text style={styles.total}>
          {info.total}
        </Text>}
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
          fixed
        />
        {info.version &&
          <Text
            style={styles.version}
            fixed
          >{info.version}
          </Text>}
        <Image
          src={calidad}
          style={styles.footerLogo}
          fixed />
      </Page>
    </Document>
  )
}

export default GenerarDescargaPdf
